export const translations = {
  es: {
    // Navbar
    knowledge: "Conocimientos",
    experience: "Exp. Laboral",
    projects: "Proyectos",
    
    // Hero Section
    hello: "Hola! soy Ine",
    welcome: "Bienvenida/o a mi portfolio. Aquí encontrarás un pequeño gran pedacito de mi vida: un resumen de mis conocimientos, experiencia laboral y proyectos.",
    learnMore: "SABER MÁS",
    
    // Explore Section
    explore: "Explora",
    knowledgeTitle: "Conocimientos",
    experienceTitle: "Experiencia Laboral", 
    projectsTitle: "Proyectos",
    
    // Social Section
    socialNetworks: "Mis redes sociales",
      // Contact Section
    contact: "Contacto",
    contactDescription: "¿Querés contactarme? Usa el form! Ingresa tus datos y te voy a responder lo antes posible.",
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Correo electrónico",
    message: "Mensaje",
    send: "ENVIAR",    sending: "ENVIANDO...",
    messageSent: "¡Mensaje enviado correctamente! Te responderé pronto.",
    messageError: "Error al enviar el mensaje. Por favor, intenta de nuevo.",
    
    // Form validation errors
    errorFirstNameRequired: "El nombre es requerido",
    errorFirstNameTooShort: "El nombre debe tener al menos 2 caracteres",
    errorLastNameRequired: "El apellido es requerido", 
    errorLastNameTooShort: "El apellido debe tener al menos 2 caracteres",
    errorEmailRequired: "El email es requerido",
    errorEmailInvalid: "Por favor ingresa un email válido",
    errorMessageRequired: "El mensaje es requerido",
    errorMessageTooShort: "El mensaje debe tener al menos 10 caracteres",
    errorMessageTooLong: "El mensaje no puede exceder 1000 caracteres",
    errorFormValidation: "Por favor corrige los errores antes de enviar",
    
    // Footer
    location: "Ubicación",
    contactInfo: "Contacto",
    montevideo: "Montevideo, Uruguay"
  },
  en: {
    // Navbar
    knowledge: "Knowledge",
    experience: "Work Experience",
    projects: "Projects",
    
    // Hero Section
    hello: "Hi! I'm Ine",
    welcome: "Welcome to my portfolio. Here you'll find a small but significant piece of my life: a summary of my knowledge, work experience, and projects.",
    learnMore: "LEARN MORE",
    
    // Explore Section
    explore: "Explore",
    knowledgeTitle: "Knowledge",
    experienceTitle: "Work Experience",
    projectsTitle: "Projects",
    
    // Social Section
    socialNetworks: "My social networks",
      // Contact Section
    contact: "Contact",
    contactDescription: "Want to get in touch? Use the form! Enter your details and I'll respond as soon as possible.",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    message: "Message",
    send: "SEND",    sending: "SENDING...",
    messageSent: "Message sent successfully! I'll respond soon.",
    messageError: "Error sending message. Please try again.",
    
    // Form validation errors
    errorFirstNameRequired: "First name is required",
    errorFirstNameTooShort: "First name must be at least 2 characters",
    errorLastNameRequired: "Last name is required",
    errorLastNameTooShort: "Last name must be at least 2 characters", 
    errorEmailRequired: "Email is required",
    errorEmailInvalid: "Please enter a valid email",
    errorMessageRequired: "Message is required",
    errorMessageTooShort: "Message must be at least 10 characters",
    errorMessageTooLong: "Message cannot exceed 1000 characters",
    errorFormValidation: "Please correct the errors before sending",
    
    // Footer
    location: "Location",
    contactInfo: "Contact",
    montevideo: "Montevideo, Uruguay"
  }
};
